import { Component, input, output, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, UntypedFormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { Integration } from 'src/app/models/integration';
import { User } from 'src/app/models/user';
import { ClientIntegrationService } from 'src/app/services/client-integration.service';
import { ToastService } from 'src/app/services/toast.service';
import { DataSourceType } from '../../../../../models/data-source-type';
import { TypeConstantService } from 'src/app/services/type-constant.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-edit-integration',
  templateUrl: './edit-integration.component.html',
  styleUrls: ['./edit-integration.component.scss'],
  providers: [ClientIntegrationService],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
})

export class EditIntegrationComponent implements OnInit, OnDestroy {

  integration = input<Integration>();
  integrations = input<Integration[]>();
  newIntegration = output<Integration>();

  dataSourceTypes: DataSourceType[] = [];
  selectedDataSourceType: DataSourceType;

  integrationName: string;
  dataSourceTypeId: string;
  errorRetentionDays: number;

  componentDestroyed$ = new Subject<boolean>();
  myControl = new UntypedFormControl();

  finishedLoading = false;
  editingIntegration = false;
  viewingIntegration = true;

  constructor(
    private clientIntegrationService: ClientIntegrationService,
    private typeConstantService: TypeConstantService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private router: Router,
    private user: User,
  ) {
  }

  ngOnInit(): void {
    this.integrationName = this.integration().name;
    this.dataSourceTypeId = this.integration().dataSourceTypeId;
    this.errorRetentionDays = this.integration().errorRetentionDays;

    this.typeConstantService.getAllDataSourceTypes()
      .subscribe((sourceTypes) => {
        this.dataSourceTypes = sourceTypes;
        this.selectedDataSourceType = this.dataSourceTypes.find((x) => x.dataSourceTypeId == this.dataSourceTypeId);

        this.finishedLoading = true;
      });
  }


  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  //Utility Methods Start
  checkAccess(role: string[]): boolean {
    return this.user.checkAccess(role);
  }

  setEditing() {
    this.viewingIntegration = false;
    this.editingIntegration = true;
  }

  cancel() {
    this.editingIntegration = false;
    this.integrationName = this.integration().name;
    this.dataSourceTypeId = this.integration().dataSourceTypeId;
    this.viewingIntegration = true;
  }

  updateIntegration() {
    if (this.checkValidFields()) {
      this.integration().name = this.integrationName;
      this.integration().dataSourceTypeId = this.selectedDataSourceType.dataSourceTypeId;
      this.integration().errorRetentionDays = this.errorRetentionDays;

      this.clientIntegrationService.updateIntegration(this.integration())
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe({
          next: () => {
            //I don't think this emitter is doing anything since nothing picks it up on editConfig component
            //Still, the editConfig updates the integration whether this is here or not
            //My best guess is the integration input here updates the integration on the parent component
            this.newIntegration.emit(this.integration());
            this.toastService.toastCreate('Successfully Updated Integration Name/DataSourceType', 'Success', {
              autoClose: false,
            });
          },
          error: (_error) => {
            this.toastService.toastCreate('Error Updating Integration Name fields', 'Danger', {
              autoClose: false,
            });
          },
        });
    }
    else {
      this.toastService.toastCreate('Invalid Input: This integration name is already in use.', 'Warning', {
        autoClose: false,
      });
    }
  }

  checkValidFields(): boolean {
    if (this.integrationName == this.integration().name) {
      //integration name is unchanged, so return true for existing valid name
      return true;
    }

    for (const c of this.integrations()) {
      if (c.name === this.integrationName) {
        return false;
      }
    }

    return true;
  }

  dataSourceTypeChange(event: any): void {
    this.selectedDataSourceType = event.value;
  }

}
